import React from "react";
import { Link } from "react-router-dom";
import { trackCta } from "../../utils/analytics";
type Variant = "primary" | "ghost" | "text";
type CtaLinkProps = {
  to: string;
  children: React.ReactNode;
  variant?: Variant;
  track: string;
  className?: string;
  external?: boolean;
  size?: "md" | "lg";
};
const base = "group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.98]";
const variants: Record<Variant, string> = {
  primary: "bg-accent text-white hover:bg-accent-bright",
  ghost: "border border-line-strong text-fg hover:border-white/40 hover:bg-white/5",
  text: "text-fg hover:text-accent-soft"
};
const sizes = {
  md: "min-h-[44px] px-5 text-[15px]",
  lg: "min-h-[52px] px-7 text-[clamp(15px,0.9rem+0.2vw,18px)]"
};
export function CtaLink({
  to,
  children,
  variant = "primary",
  track,
  className = "",
  external,
  size = "md"
}: CtaLinkProps) {
  const cls = `${base} ${variants[variant]} ${variant === "text" ? "" : sizes[size]} ${className}`;
  const onClick = () => trackCta(track, to);
  if (external || to.startsWith("tel:") || to.startsWith("mailto:")) {
    return <a href={to} className={cls} onClick={onClick} data-id="element-443" data-mp="128vdefjqstm8">
        {children}
      </a>;
  }
  return <Link to={to} className={cls} onClick={onClick} data-id="element-444" data-mp="xb3ozvib3pms">
      {children}
    </Link>;
}